module.exports = __webpack_public_path__ + "static/media/HCP_Guide_DIG_LAYOUT.87c3c847.pdf";